import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.svg';

function Header({ isInWordPage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 0) return;

      if (currentScrollY < lastScrollY) {
        setShowHeader(true);
      } else if (currentScrollY > lastScrollY) {
        if (currentScrollY > 10) {
          setShowHeader(false);
        }
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = ''; 
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);


  return (
    <div className={`fixed transition-transform duration-300 ease-in-out ${showHeader ? 'translate-y-0' : '-translate-y-full'} `} style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }} >
      <div className="relative flex font-fraunces justify-between items-center lg:pr-16 md:pr-12 pr-8 py-4 text-2xl">
        {/*Logo*/}
        <Link to="/" className="flex-shrink-0" onClick={() => window.scrollTo({ top:0, behavior:'smooth'})}>
        <img src={logo} alt="logo" loading="lazy" className="w-[175px] md:w-[300px]"/>
        </Link>

        {/* boutons */}
        <div className="flex items-center md:ml-16 space-x-10">
          <Link to="/download" className="text-white border border-[#000B23] rounded-[16px] font-bold whitespace-nowrap px-4 py-2 text-base md:px-6 md:py-3 md:text-xl bg-[#000B23]" >
            <span className="hidden md:inline">Télécharger l'app !</span>
            <span className="inline md:hidden">Télécharger</span>
          </Link>

          {/* Liens */}
          <div className="hidden lg:flex lg:items-center lg:space-x-10 font-bold">
            <Link to="/entreprise" className={`transition-colors ${isInWordPage ? 'text-white' : 'text-black'}`}>Entreprise</Link>
            <Link to="/contact" className={`transition-colors ${isInWordPage ? 'text-white' : 'text-black'}`}>Contact</Link>
          </div>
        </div>

        {/* Bouton hamburger */}
        <button className="right-4 lg:hidden flex flex-col items-center md:gap-[10px] gap-[8px]" onClick={() => setIsMenuOpen(true)}>
          <span className={`block md:w-10 md:h-1.5 w-8 h-1 rounded transition-colors ${isInWordPage ? 'bg-white' : 'bg-black'}`}></span>
          <span className={`block md:w-10 md:h-1.5 w-8 h-1 rounded transition-colors ${isInWordPage ? 'bg-white' : 'bg-black'}`}></span>
          <span className={`block md:w-10 md:h-1.5 w-8 h-1 rounded transition-colors ${isInWordPage ? 'bg-white' : 'bg-black'}`}></span>
        </button>



        {/* Menu mobile*/}
        <div className={`fixed inset-0 h-screen bg-white z-50 flex flex-col overflow-y-auto space-y-8 transform transition-transform duration-500 ease-in-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
            
            {/* Logo */}
            <div className="relative flex justify-between items-center pr-8 py-4 text-2xl">
              <Link to="/" className="flex-shrink-0" onClick={() => { window.scrollTo({ top:0, behavior:'smooth'}); setIsMenuOpen(false);}}>
                <img src={logo} alt="logo" loading="lazy" className="md:w-[325px] w-[175px]" />
              </Link>

              {/* Bouton fermer */}
              <button className="absolute top-4 right-0 md:text-6xl text-4xl md:pr-20 pr-8" onClick={() => setIsMenuOpen(false)} >
                &times;
              </button>
            </div>

            {/* Menu verticale */}
            <nav className="flex flex-col items-start font-medium text-base pl-8 pt-4">
              <span className="md:text-5xl text-2xl font-bold mb-1">Application</span>
              <Link to="/#a-quoi-ca-sert" className="hover:text-blue-700 pl-4 md:mt-6 mt-2 md:text-3xl text-xl" onClick={() => setIsMenuOpen(false)}>A quoi ça sert ?</Link>
              <Link to="/#fonctionnalites" className="hover:text-blue-700 pl-4 md:-6 mt-2 md:text-3xl text-xl" onClick={() => setIsMenuOpen(false)}>Fonctionnalités</Link>

              <span className="md:text-5xl text-2xl font-bold mt-6 mb-1">Pages utiles</span>
              <Link to="/" className="hover:text-blue-700 pl-4 md:mt-6 mt-2 md:text-3xl text-xl" onClick={() => { window.scrollTo({ top:0, behavior:'smooth'}); setIsMenuOpen(false);}}>Accueil</Link>
              <Link to="/entreprise" className="hover:text-blue-700 pl-4 md:mt-6 mt-2 md:text-3xl text-xl" onClick={() => setIsMenuOpen(false)}>Entreprise</Link>

              <span className="md:text-5xl text-2xl font-bold mt-6 mb-1">Support</span>
              <Link to="/contact" className="hover:text-blue-700 pl-4 md:mt-6 mt-2 md:text-3xl text-xl" onClick={() => setIsMenuOpen(false)}>Nous contacter</Link>
            </nav>


            {/* Bouton Télécharger */}
            <div className="flex justify-center">
              <Link to="/download" className="text-white md:text-4xl border border-[#000B23] px-6 py-3 rounded-[16px] font-bold bg-[#000B23]" onClick={() => setIsMenuOpen(false)}>
                Télécharger
              </Link>
            </div>
          </div>
        

      </div>
    </div>
  );
}

export default Header;
